(ns ncr.fragment.props.money
  (:refer-clojure :exclude [zero?])
  (:require [clojure.string :as s]
            [cljs.core.async :as async :refer-macros [go] :refer [<!]]
            [ncr.etc.alert :as a]
            [ncr.backend :as b]
            [tick.locale-en-us]
            ["bignumber.js" :as big]
            [ncr.etc.util :as u]
            [ncr.etc.parse-numbers :as pn]
            [ncr.etc.pubsub :as ps]
            [cljc.java-time.local-date]
            [goog.object :as gob])
  (:import [goog.i18n NumberFormat NumberFormatSymbols_de NumberFormatSymbolsType]
           [goog.i18n.NumberFormat Format]))

(def money-precision 20)
(def money-scale 2)

(defn parse-all [s]
  (map
    (fn [x] (big/BigNumber. (if x (.toFixed x money-scale) js/NaN)))
    (pn/parse-all s)))

(def money ; german
  {:pattern "#,##0.00"
   :decimal-separator \,
   :group-separator \.})

(defn decimal-format [{:keys [pattern decimal-separator group-separator]}]
  (NumberFormat.
    (.-DECIMAL Format)
    nil
    nil
    (let [^NumberFormatSymbolsType symbols (gob/clone NumberFormatSymbols_de)]
      (set! (.-DECIMAL_PATTERN symbols) pattern)
      (set! (.-CURRENCY_PATTERN symbols) pattern)
      (set! (.-DECIMAL_SEP symbols) decimal-separator)
      (set! (.-GROUP_SEP symbols) group-separator)
      symbols)))

(defn to-bignumber [num]
  (big/BigNumber.
    (try
      (.toFixed num money-scale)
      (catch js/Error _
        nil))))

(defn parse [s]
  (when-not (s/blank? s)
    (or (to-bignumber (.parse (decimal-format money) s)) js/NaN)))

(defn to-string
  ([m default]
   (if (some? m)
     (let
       [nf (decimal-format money)]
       (.format nf m))
     default))
  ([m]
   (to-string m "")))

(defn zero? [^js m]
  (.isZero m))

(def zero
  (big/BigNumber. 0))

(defn value-or-zero [value]
  (or value zero))

(defn valid? [^js m]
  (or (nil? m)
    (and
      (.isFinite m)
      (<= (.decimalPlaces m) money-scale)
      (<=
        (-> m
          (.toFixed money-scale)
          (big/BigNumber.)
          (.precision))
        money-precision))))

#_(= (big/BigNumber. "10") (big/BigNumber. "10"))
#_(valid? (parse "123456789012345679.12"))

(defn equals [^js a ^js b]
  (cond
    (and (instance? big/BigNumber a) (instance? big/BigNumber b))
    (.isEqualTo a b)

    (and (nil? a) (nil? b))
    true

    :else
    false))

#_(let [m1 (Money. (big/BigNumber. "123"))
        m2 (Money. (big/BigNumber. "123"))
        m3 (make-money "kjkj")]
    (equals' m1 m2)
    (tagged-value m1)
    (valid? m3))

#_(def x (big/BigNumber. "77"))

#_(instance? big/BigNumber nil)

#_(equals' x (big/BigNumber. "77.1"))

(defn !mass-set-netto [me fragments]
  (go
    (if-let [ratio
             (js/prompt "Please enter netto to brutto ratio (0.0 to 1.0)")]
      (let [r (js/parseFloat ratio)]
        (if-not (<= 0 r 1)
          (js/alert (str "Invalid ratio value: " ratio))
          (let [muts
                (keep
                  (fn [{:keys [id properties]}]
                    (when-let [brutto (:common/brutto properties)]
                      (let [netto (to-bignumber (* r brutto))]
                        [(keyword id)
                         [:properties_patch
                          {:reference id
                           :properties
                           (u/transit-write {:common/netto netto})}]])))
                  fragments)]
            (when (<!
                    (a/!fragment-operation
                      {:operation-title
                       (u/format "Setting netto to %s * brutto" ratio)
                       :success-title
                       (u/format "Set netto to %s * brutto" ratio)

                       :fragments fragments}
                      (b/!multi-mutation muts)))
              (ps/pub! [:me/load])))))
      [:error :cancel])))
